var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlignRight2Icon = function SvgAlignRight2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.8.8c.22 0 .4.18.4.4v13.6a.4.4 0 0 1-.4.4H14a.4.4 0 0 1-.4-.4v-3.6h-12a.8.8 0 0 1-.8-.8V5.6a.8.8 0 0 1 .8-.8h12V1.2c0-.22.179-.4.4-.4h.8Zm-1.2 8.8V6.4H2.4v3.2h11.2Z",
    clipRule: "evenodd"
  })));
};
export default SvgAlignRight2Icon;